import { useMemo } from "react";

import { useAuthenticator } from "@aws-amplify/ui-react";

import { useAuthClaims } from "app/contexts/AuthClaimsContext";

import type { AuthClaims } from "app/contexts/AuthClaimsContext";
import type { AuthUser } from "aws-amplify/auth";

export type { Identity } from "app/contexts/AuthClaimsContext";

/**
 * The Authenticator's user plus the ID token claims. Partial because outside
 * the Cognito sign-in (local dev) the Authenticator has no user.
 */
export type UserWithIdentity = Partial<AuthUser> & AuthClaims;

export function useUserWithIdentity(): UserWithIdentity {
  const { user } = useAuthenticator((context) => [context.user]);
  const claims = useAuthClaims();

  return useMemo(() => ({ ...user, ...claims }), [user, claims]);
}
